import { PAYMENT_SUCCESS, PAYMENT_ERROR, PAYMENT_ERROR_CLEAR } from "../actions/PaymentActions";


const errorReducer = function(state = null, action) {
  switch (action.type) {
    case PAYMENT_SUCCESS: {
      return null;
    }
    case PAYMENT_ERROR: {
      return action.payload.data.message
    }
    case PAYMENT_ERROR_CLEAR: {
      return null;
    }
    default: {
      return state;
    }
  }
};

export default errorReducer;
